import { Svg } from '../../../components/Svg';
import { jsx as _jsx } from "react/jsx-runtime";
const MarketingStudioIcon = () => {
  return /*#__PURE__*/_jsx(Svg, {
    $size: "32px",
    $color: "currentColor",
    $alignWithText: false,
    viewBox: "0 0 32 32",
    children: /*#__PURE__*/_jsx("path", {
      d: "M25 6H22V5C22 4.44 21.56 4 21 4C20.44 4 20 4.44 20 5V6H12V5C12 4.44 11.56 4 11 4C10.44 4 10 4.44 10 5V6H7C5.34 6 4 7.34 4 9V13C4 13.56 4.44 14 5 14H23C23.56 14 24 13.56 24 13C24 12.44 23.56 12 23 12H6V9C6 8.44 6.44 8 7 8H10V9C10 9.56 10.44 10 11 10C11.56 10 12 9.56 12 9V8H20V9C20 9.56 20.44 10 21 10C21.56 10 22 9.56 22 9V8H25C25.56 8 26 8.44 26 9V19H22C20.34 19 19 20.34 19 22V26H7C6.44 26 6 25.56 6 25V17C6 16.44 5.56 16 5 16C4.44 16 4 16.44 4 17V25C4 26.66 5.34 28 7 28H20C20.14 28 20.26 27.98 20.38 27.92C20.5 27.86 20.62 27.8 20.7 27.7L27.7 20.7C27.7 20.7 27.86 20.5 27.92 20.38C27.98 20.26 28 20.12 28 20V9C28 7.34 26.66 6 25 6ZM21 24.58V22C21 21.44 21.44 21 22 21H24.58L21 24.58Z",
      fill: "currentColor"
    })
  });
};
export default MarketingStudioIcon;